import React from "react";
import { TechnicianData, TechnicianDto } from "../../generated";
import Store from "../TechiniciansStore";
import { Loading } from "../../common/components/loading";
import { clone } from "lodash";
import OpenModalButton from "../../common/components/openModalButton";
import TechnicianForm from "./TechinicianForm";
import TechiniciansActions from "../TechiniciansActions";

interface Props {
    label?: string;
    selected: TechnicianDto[],
    onChange: (data: TechnicianDto[] | null) => void
}
export const TechniciansFilter = ({ onChange, selected, label }: Props) => {
    const allTechnicians = Store.useAll();
    const onAddItem = (t: TechnicianDto) => {
        onChange([...selected || [], t])
    }
    const onRemoveItem = (t: TechnicianDto) => {
        const cloned = clone(selected);
        let indexToRemove = cloned.indexOf(t);
        cloned.splice(indexToRemove, 1);
        onChange(cloned);
    }

    if (!allTechnicians)
        return <Loading />
    const modal = React.useRef<OpenModalButton>(null);
    return <div className="alert alert-secondary mb-0">
        {label && <label className="form-label text-uppercase" style={{ fontSize: "0.8rem" }}>{label}</label>}
        <div className="d-flex flex-wrap align-items-center">
            {allTechnicians.map(t => {
                const isSelected = selected.find(x => x.id === t.id) != null;
                const techName = `${t.firstName} ${t.lastName}`
                return (<button
                    key={t.id}
                    title={`${isSelected ? "Escludi" : "Includi"} ${techName} dalla visualizzazione`}
                    style={{ backgroundColor: isSelected ? t.color : "white", color: isSelected ? "white" : t.color, borderColor: !isSelected ? t.color : undefined, boxShadow: "none" }}
                    className={`btn me-2`}
                    type="button"
                    onClick={() => isSelected ? onRemoveItem(t) : onAddItem(t)}>
                    <span style={{ whiteSpace: "nowrap" }}>
                        <i className={`${isSelected ? "far fa-check-square" : "far fa-square"} me-1`} /> {techName}
                    </span>
                </button>);
            })}
            <OpenModalButton
                ref={modal}
                className="btn btn-secondary justify-self-end"
                modalContent={
                    <TechnicianForm
                        onSubmit={tech => TechiniciansActions.add(tech)}
                        technician={new TechnicianData()}
                        onCancel={() => modal?.current?.close()}
                    />
                }
            >
                <span className="text-nowrap">
                    <i className="fas fa-plus me-1" /> Tecnico
                </span>
            </OpenModalButton>
        </div>
    </div>
}
